module.exports = __webpack_public_path__ + "static/media/m.b7266a75.png";